module.exports = __webpack_public_path__ + "media/images/num2_ic-off-f793b84e14d9f66d0b13d009048dbb72.svg";